/* eslint-disable react-hooks/exhaustive-deps */
import { Option, Select } from '@sede-enterprise/shell-ds-react-framework';
import React, { useEffect, useState } from 'react'
import { getName } from '../util/analysisUtils';



const commonfeatures = ["Measured wall thickness", "Measured corrosion rate", "Minimum Required wall thickness",
    "Predicted wall thickness",
    "Predicted corrosion rate",
];

const AnalysisSelection = ({ featureOptions, selectedSubjects, setPassedFeatureEverywhere, setPassedSubjectsEverywhere, passedFeature }) => {

    const [features, setFeatures] = useState();

    const [selectedFeatures, setSelectedFeatures] = useState();


    const [error, setError] = useState('');
    const [featureError, setFeatureError] = useState('');

    const [selectedCLs, setSelectedCLs] = useState([]);
    const [selectedCMLs, setSelectedCMLs] = useState([]);
    const [selectedSensors, setSelectedSensors] = useState([]);

    const [removedItems, setRemovedItems] = useState([]);

    console.log(selectedFeatures)

    //Set Feature Options
    useEffect(() => {
        if (featureOptions) {
            const featureObj = featureOptions.map((feature) => {
                return {
                    id: feature,
                    name: getName(feature)
                };
            });


            const commomFeaturesObj = featureObj.filter(feature => commonfeatures.includes(feature.name));
            const otherFeaturesObj = featureObj.filter(feature => !commonfeatures.includes(feature.name));
            const sortedFeatures = [...commomFeaturesObj, ...otherFeaturesObj];
            console.log("Sorted features", sortedFeatures);
            setFeatures(sortedFeatures);
            // Set the first feature as the default selected feature
            if (selectedFeatures?.length === 0) {
                setSelectedFeatures([JSON.stringify(sortedFeatures[0])]);
                setPassedFeatureEverywhere([sortedFeatures[0]]);
            }
            if (selectedFeatures?.length > 0) {
                // Keep the selected features that are still available in the new feature options
                const updatedSelectedFeatures = selectedFeatures.filter(feature => featureOptions.map(feature => feature).includes(JSON.parse(feature).id));
                setSelectedFeatures(updatedSelectedFeatures)
                setPassedFeatureEverywhere(updatedSelectedFeatures.map(feature => JSON.parse(feature)));
            }
        }
    }, [featureOptions])

    // Set default values for setPassedSubjectsEverywhere
    useEffect(() => {

        const defaultSelectedSubjects = selectedSubjects.length > 1 && selectedSubjects.map(subject => JSON.stringify(subject));

        if (defaultSelectedSubjects) {

            //Extract CLs from defaultSelectedSubjects
            const parsedSelectedCLs = defaultSelectedSubjects.filter(subject => JSON.parse(subject).type === "Corrosion Loop").map(subject => JSON.parse(subject));

            //Extract CMLs from defaultSelectedSubjects
            const parsedSelectedCMLs = defaultSelectedSubjects.filter(subject => JSON.parse(subject).type === "Condition Monitoring Location").map(subject => JSON.parse(subject));

            //Extract Sensors from defaultSelectedSubjects
            const parsedSelectedSensors = defaultSelectedSubjects.filter(subject => JSON.parse(subject).type === "Sensor").map(subject => JSON.parse(subject));

            // Exclude removed items from parsedSelectedCMLs
            const filteredSelectedCMLs = parsedSelectedCMLs.filter(cml => !removedItems.includes(JSON.stringify(cml)));

            // Exclude removed items from parsedSelectedSensors
            const filteredSelectedSensors = parsedSelectedSensors.filter(sensor => !removedItems.includes(JSON.stringify(sensor)));

            // Limit the number of CMLs to 6
            const limitedSelectedCMLs = filteredSelectedCMLs.slice(0, 6);

            // Limit the number of Sensors to 6
            const limitedSelectedSensors = filteredSelectedSensors.slice(0, 6);

            // Filter out CLs that do not have any selected CMLs or Sensors
            const filteredSelectedCLs = parsedSelectedCLs.filter(cl => {
                const clId = cl.corrosionLoopId;
                return limitedSelectedCMLs.some(cml => cml.corrosionLoopId === clId) || limitedSelectedSensors.some(sensor => sensor.corrosionLoopId === clId);
            });

            //Set Selected CLs, CMLs and Sensors
            const stringifiedSelectedCLs = filteredSelectedCLs.map(cl => JSON.stringify(cl));
            const stringifiedSelectedCMLs = limitedSelectedCMLs.map(cml => JSON.stringify(cml));
            const stringifiedSelectedSensors = limitedSelectedSensors.map(sensor => JSON.stringify(sensor));

            setSelectedCLs(stringifiedSelectedCLs);
            setSelectedCMLs(stringifiedSelectedCMLs);
            setSelectedSensors(stringifiedSelectedSensors);

            setPassedSubjectsEverywhere([...limitedSelectedCMLs, ...limitedSelectedSensors]);
        }

        if (!defaultSelectedSubjects) {
            setError('')
            setSelectedCLs([])
            setSelectedCMLs([])
            setSelectedSensors([])
            setSelectedFeatures([])
            setPassedFeatureEverywhere([])
            setPassedSubjectsEverywhere([])
        }

    }, [selectedSubjects]);

    const handleRemoveItem = (item) => {
        setRemovedItems([...removedItems, item]);
    };


    const selectedCLIds = selectedCLs.map(cl => JSON.parse(cl).corrosionLoopId);
    const filteredCMLs = selectedSubjects.filter(subject => {
        // Show all CMLs if no CL is selected, otherwise filter by selected CLs' ids
        return (selectedCLIds.length === 0 || selectedCLIds.includes(subject.corrosionLoopId)) && subject.type === "Condition Monitoring Location";
    });

    const selectedCMLIds = selectedCMLs.map(cml => JSON.parse(cml).name);

    const filteredSensors = selectedSubjects.filter(subject => {

        // Show all Sensors if no CL || CML is selected, otherwise filter by selected CLs' ids or CMLs' ids
        return (selectedCLIds.length === 0 || selectedCLIds.includes(subject.corrosionLoopId)) &&
            (selectedCMLIds.length === 0 || selectedCMLIds.includes(subject.cmlId)) && subject.type === "Sensor";

    });




    useEffect(() => {
        const isBonga = selectedSubjects.filter(subject => subject.site === "BON").length > 0;

        // If Bonga remove viscosity and density from features
        if (isBonga) {
            const updatedFeatures = features?.filter(feature => feature.id !== "Viscosity" && feature.id !== "Density");
            setFeatures(updatedFeatures);
        }
        // else have all features
        else {
            setFeatures(featureOptions)
        }

    }, [selectedSubjects])


    return (
        <div className='parent-container' id='analysis-selection-id-1'>
            <div className='content-container' id='analysis-selection-id-2'>
                <div className='content-header' id='analysis-selection-id-3'>
                    <h2 id='analysis-selection-id-4'>Selected List</h2>
                </div>
                <div className='analysis-selection-container' id='analysis-selection-id-5'>
                    <div className='analysis-subjects-selection' id='analysis-selection-id-6'>
                        <div className='selected-CLs' id='analysis-selection-id-7'>
                            <Select mode='multiple' placeholder="Select CLs"
                                id='analysis-selection-id-8'
                                disabled={selectedSubjects.filter(subject => subject.type === "Corrosion Loop").length < 1} showSearch={true}
                                key={selectedCLs}
                                optionFilterProp='description'
                                allowClear={false}
                                value={selectedCLs}
                                onChange={(value) => {
                                    const parsedValue = value.map(subject => JSON.parse(subject));

                                    // Determine newly selected and deselected CLs
                                    const previousCLIds = selectedCLs.map(cl => JSON.parse(cl).corrosionLoopId);
                                    const currentCLIds = parsedValue.map(cl => cl.corrosionLoopId);
                                    const deselectedCLIds = previousCLIds.filter(id => !currentCLIds.includes(id));

                                    // Filter out CMLs that are associated with the deselected CLs
                                    let updatedSelectedCMLs = selectedCMLs;
                                    if (deselectedCLIds.length > 0) {
                                        updatedSelectedCMLs = selectedCMLs.filter(cml => {
                                            const parsedCML = JSON.parse(cml);
                                            return !deselectedCLIds.includes(parsedCML.corrosionLoopId);
                                        });
                                    }

                                    // Filter out Sensors that are associated with the deselected CLs
                                    let updatedSelectedSensors = selectedSensors;
                                    if (deselectedCLIds.length > 0) {
                                        updatedSelectedSensors = selectedSensors.filter(sensor => {
                                            const parsedSensor = JSON.parse(sensor);
                                            return !deselectedCLIds.includes(parsedSensor.corrosionLoopId);
                                        });
                                    }

                                    // If a CL is selected, ensure only CMLs with matching corrosionLoopId remain selected
                                    if (currentCLIds.length > 0) {
                                        updatedSelectedCMLs = updatedSelectedCMLs.filter(cml => {
                                            const parsedCML = JSON.parse(cml);
                                            return currentCLIds.includes(parsedCML.corrosionLoopId);
                                        });
                                    }

                                    // If a CL is selected, ensure only Sensors with matching corrosionLoopId remain selected
                                    if (currentCLIds.length > 0) {
                                        updatedSelectedSensors = updatedSelectedSensors.filter(sensor => {
                                            const parsedSensor = JSON.parse(sensor);
                                            return currentCLIds.includes(parsedSensor.corrosionLoopId);
                                        });
                                    }

                                    // Update state with the new selections
                                    setPassedSubjectsEverywhere([...updatedSelectedCMLs.map(cml => JSON.parse(cml)), ...updatedSelectedSensors.map(sensor => JSON.parse(sensor))]);
                                    setSelectedCLs(value); // Update selected CLs
                                    setSelectedCMLs(updatedSelectedCMLs); // Update selected CMLs to exclude those from deselected CLs or not matching current CLs
                                    setSelectedSensors(updatedSelectedSensors); // Update selected Sensors to exclude those from deselected CLs or not matching current CLs
                                }}
                            >
                                {selectedSubjects?.length > 1 && selectedSubjects.slice(1).map((subject) => subject.type === "Corrosion Loop" && <Option key={JSON.stringify(subject)} description={subject.name} id='analysis-selection-id-9'>
                                    <div className='subject-type' id='analysis-selection-id-10'>{subject.type}</div>
                                    <div className='subject-name' id='analysis-selection-id-11'>{subject.name}</div>
                                </Option>
                                )}
                            </Select>
                        </div>
                        <div className='selected-CMLs-Sensors' id='analysis-selection-id-182'>
                            <div className='selected-CMLs' id='analysis-selection-id-12'>
                                {error && <p className='data-label error-label' id='analysis-selection-id-93'>{error}</p>}
                                <Select id='analysis-selection-id-13' mode='multiple' placeholder="Select CMLs"
                                    disabled={selectedSubjects.filter(subject => subject.type === "Condition Monitoring Location").length < 1} showSearch={true}
                                    key={selectedCMLs}
                                    allowClear={false}
                                    onDeselect={handleRemoveItem}
                                    optionFilterProp='description'
                                    value={selectedCMLs}
                                    onChange={(value) => {
                                        if (value.length > 6) {
                                            setError('You can only select a maximum of 6 items.');
                                            return;
                                        }
                                        const parsedValue = value.map(subject => JSON.parse(subject));

                                        // Determine newly selected and deselected CMLs
                                        const previousCMLIds = selectedCMLs.map(cml => JSON.parse(cml).name);
                                        const currentCMLIds = parsedValue.map(cml => cml.name);
                                        const deselectedCMLIds = previousCMLIds.filter(id => !currentCMLIds.includes(id));

                                        // Filter out Sensors that are associated with the deselected CMLs
                                        let updatedSelectedSensors = selectedSensors;
                                        if (deselectedCMLIds.length > 0) {
                                            updatedSelectedSensors = selectedSensors.filter(sensor => {
                                                const parsedSensor = JSON.parse(sensor);
                                                return !deselectedCMLIds.includes(parsedSensor.cmlId);
                                            });
                                        }

                                        // If a CML is selected, ensure only Sensors with matching name remain selected
                                        if (currentCMLIds.length > 0) {
                                            updatedSelectedSensors = updatedSelectedSensors.filter(sensor => {
                                                const parsedSensor = JSON.parse(sensor);
                                                return currentCMLIds.includes(parsedSensor.cmlId);
                                            });
                                        }

                                        setError('');
                                        setPassedSubjectsEverywhere([...parsedValue])
                                        setSelectedCMLs(value);
                                        setSelectedSensors(updatedSelectedSensors);
                                    }}
                                >
                                    {filteredCMLs.map((subject) => <Option id='analysis-selection-id-14' key={JSON.stringify(subject)} description={subject.shortname}>
                                        <div className='subject-type' id='analysis-selection-id-15'>{subject.type}</div>
                                        <div className='subject-name' id='analysis-selection-id-16'>{subject.shortname}</div>
                                    </Option>
                                    )}
                                </Select>
                            </div>
                            {filteredSensors.length > 0 && <div className='selected-Sensors' id='analysis-selection-id-112'>
                                {error && <p className='data-label error-label' id='analysis-selection-id-193'>{error}</p>}
                                <Select id='analysis-selection-id-113' mode='multiple' placeholder="Select Sensors"
                                    disabled={selectedSubjects.filter(subject => subject.type === "Sensor").length < 1} showSearch={true}
                                    key={selectedSensors}
                                    allowClear={false}
                                    onDeselect={handleRemoveItem}
                                    optionFilterProp='description'
                                    value={selectedSensors}
                                    onChange={(value) => {
                                        if (value.length > 6) {
                                            setError('You can only select a maximum of 6 items.');
                                            return;
                                        }
                                        const parsedValue = value.map(subject => JSON.parse(subject));
                                        setError('');
                                        setPassedSubjectsEverywhere([...parsedValue])
                                        setSelectedSensors(value);
                                    }}
                                >
                                    {filteredSensors.map((subject) => <Option id='analysis-selection-id-14' key={JSON.stringify(subject)} description={subject.shortname}>
                                        <div className='subject-type' id='analysis-selection-id-15'>{subject.type}</div>
                                        <div className='subject-name' id='analysis-selection-id-16'>{subject.name}</div>
                                    </Option>
                                    )}
                                </Select>
                            </div>}

                        </div>
                    </div>
                    <div className='analysis-features-selection' id='analysis-selection-id-17'>
                        {featureError && <p className='data-label error-label' id='analysis-selection-id-953'>{featureError}</p>}
                        {featureOptions?.length > 0 && <Select id='analysis-selection-id-18' mode='multiple' placeholder="Select Features"
                            disabled={selectedSubjects?.length <= 1}
                            allowClear={false}
                            value={selectedFeatures}
                            showSearch={true}
                            onChange={(value) => {

                                const parsedValue = value.map(feature => JSON.parse(feature));
                                if (value.length > 6) {
                                    setFeatureError('You can only select a maximum of 6 items.');
                                    return;
                                }
                                setFeatureError('');
                                setPassedFeatureEverywhere(parsedValue)
                                setSelectedFeatures(value)
                            }}
                        >
                            {features?.map((feature) => <Option key={JSON.stringify(feature)} id='analysis-selection-id-19'>
                                {feature.name}
                            </Option>
                            )}
                        </Select>}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default AnalysisSelection